import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import '../styles/Perfil.css';

export default function Perfil() {
  const { user, logout } = useContext(AuthContext);
  const [name, setName] = useState(user?.name || '');
  const [email, setEmail] = useState(user?.email || '');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await fetch('/api/auth/update-profile', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ name })
      });
      const data = await res.json();
      if (data.success) {
        setMessage('✓ Perfil atualizado com sucesso!');
        setTimeout(() => setMessage(''), 3000);
      }
    } catch (error) {
      setMessage('✗ Erro ao atualizar perfil');
    }
    setLoading(false);
  };

  return (
    <div className="perfil-page">
      <h1>⚙️ Meu Perfil</h1>

      <div className="perfil-card">
        <h2>Informações Pessoais</h2>
        <form onSubmit={handleSave}>
          <div className="form-group">
            <label>Nome</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="input-field"
            />
          </div>

          <div className="form-group">
            <label>Email (não pode ser alterado)</label>
            <input
              type="email"
              value={email}
              disabled
              className="input-field disabled"
            />
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar Alterações'}
          </button>

          {message && <p className="message">{message}</p>}
        </form>
      </div>

      <div className="perfil-card danger">
        <h2>Sair da Conta</h2>
        <button
          onClick={() => { logout(); window.location.href = '/login'; }}
          className="btn-danger"
        >
          Sair
        </button>
      </div>
    </div>
  );
}
